<template>
    <modal name="modalProgramGroupContribution" :width="'55%'" :height="'auto'" :click-to-close="false">
        <form @submit.prevent="saveContribution">

            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closeModal">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title">Agregar Aportación</h5>
            </div>

            <div class="modal-body">

                <label>Origen del dinero</label>
                <select class="form-control" v-model="form.source_key">
                    <option value="">Seleccione</option>
                    <option value="wallet">Desde monedero</option>
                    <option value="direct">Aportación directa</option>
                </select>
                <div v-if="errors.source_key" class="text-danger">{{ errors.source_key[0] }}</div>

                <div class="mt-3" v-if="form.source_key === 'wallet'">
                    <label>Cuenta origen (monedero)</label>
                    <select class="form-control" v-model="form.bank_id" @change="loadWallet">
                        <option value="">Seleccione</option>
                        <option v-for="(acc, index) in catalogue.bank_accounts_companys" :key="index" :value="acc.id">
                            {{ acc.bank?.name || 'Banco' }} - {{ acc.account_number || acc.number || ('Cuenta #' +
                                acc.id) }}
                        </option>
                    </select>
                    <div v-if="errors.bank_id" class="text-danger">
                        {{ errors.bank_id[0] }}
                    </div>

                    <div class="alert alert-success mt-3" v-if="form.bank_id">
                        <strong>Saldo en monedero:</strong> {{ Number(wallet_balance || 0) | toCurrency }}
                    </div>
                </div>

                <div class="mt-3">
                    <label>Cuenta bancaria destino</label>
                    <select class="form-control" v-model="form.bank_account_company_id">
                        <option value="">Seleccione</option>
                        <option v-for="(account, index) in catalogue.bank_accounts_groups" :value="account.id"
                            :key="index">
                            {{ account.label }}
                        </option>
                    </select>
                    <div v-if="errors.bank_account_company_id" class="text-danger">
                        {{ errors.bank_account_company_id[0] }}
                    </div>
                </div>

                <div class="mt-3">
                    <label>Tipo de movimiento</label>
                    <select class="form-control" v-model="form.type_payments_id">
                        <option value="">Seleccione</option>
                        <!-- <option value="1">Depósito</option> -->
                        <option value="2">Transferencia</option>
                        <option value="5">Efectivo</option>
                    </select>
                    <div v-if="errors.type_payments_id" class="text-danger">{{ errors.type_payments_id[0] }}</div>
                </div>

                <div class="mt-3">
                    <label>Fecha</label>
                    <date-picker v-model="form.date" format="YYYY-MM-DD" valueType="format"></date-picker>
                    <div v-if="errors.date" class="text-danger">{{ errors.date[0] }}</div>
                </div>

                <div class="mt-3">
                    <label>Monto total pagado</label>
                    <money class="form-control" v-model="form.amount"></money>
                    <div v-if="errors.amount" class="text-danger">{{ errors.amount[0] }}</div>
                </div>

                <div v-if="form.source_key === 'wallet' && Number(form.amount) > Number(wallet_balance)"
                    class="text-danger mt-1">
                    El monto excede el saldo disponible.
                </div>

                <div class="mt-4">
                    <label><strong>Distribución manual</strong></label>

                    <div class="table-responsive" v-if="contributionSlots.length">
                        <table class="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th>Aportación</th>
                                    <th>Monto esperado</th>
                                    <th>Pendiente</th>
                                    <th>Aplicar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(slot, key) in contributionSlots" :key="key">
                                    <td>{{ slot.label }}</td>
                                    <td>{{ Number(slot.amount || slot.expected_amount || 0) | toCurrency }}</td>
                                    <td>{{ Number(slot.pending_amount || slot.amount || 0) | toCurrency }}</td>
                                    <td style="width: 160px;">
                                        <money class="form-control form-control-sm" v-model="slot.apply_amount"
                                            @input="normalizeApplyAmount(slot)"></money>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-else class="alert alert-warning mb-0">
                        No hay aportaciones disponibles para aplicar.
                    </div>

                    <div class="mt-2">
                        <strong>Total a aplicar:</strong> {{ totalApplyAmount | toCurrency }}
                    </div>

                    <div class="mt-2">
                        <strong>Total pendiente:</strong> {{ totalPendingAmount | toCurrency }}
                    </div>

                    <div v-if="Number(totalApplyAmount) > Number(form.amount || 0)" class="text-danger mt-1">
                        El total aplicado no puede ser mayor al monto capturado.
                    </div>

                    <div v-if="Number(totalApplyAmount) < Number(totalPendingAmount) && Number(form.amount || 0).toFixed(2) !== Number(totalApplyAmount || 0).toFixed(2)"
                        class="text-danger mt-1">
                        Debe aplicar todo el monto pagado mientras existan aportaciones pendientes.
                    </div>

                    <div v-if="Number(totalApplyAmount) <= 0 && contributionSlots.length" class="text-danger mt-1">
                        Debe capturar al menos un monto a aplicar.
                    </div>

                    <div class="mt-2" v-if="isAllPendingCovered && Number(excessAmount) > 0">
                        <strong class="text-success">Excedente:</strong>
                        <span class="text-success">{{ excessAmount | toCurrency }}</span>
                    </div>

                    <div class="mt-3" v-if="isAllPendingCovered && Number(excessAmount) > 0">
                        <label>Cuenta destino del excedente</label>
                        <select class="form-control" v-model="form.excess_bank_id">
                            <option value="">Seleccione</option>
                            <option v-for="(acc, index) in catalogue.bank_accounts_companys" :key="index"
                                :value="acc.id">
                                {{ acc.bank?.name || 'Banco' }} - {{ acc.account_number || acc.number || ('Cuenta #' +
                                acc.id) }}
                            </option>
                        </select>
                        <div v-if="errors.excess_bank_id" class="text-danger">
                            {{ errors.excess_bank_id[0] }}
                        </div>
                    </div>

                    <div v-if="isAllPendingCovered && Number(excessAmount) > 0" class="alert alert-info mt-3 mb-0">
                        <strong>Excedente detectado:</strong>
                        {{ Number(excessAmount || 0) | toCurrency }}.<br>
                        Este monto será enviado al monedero en la cuenta seleccionada.
                    </div>
                </div>

                <div class="mt-4 mb-3">
                    <hr>
                    <button type="submit" class="btn btn-outline-success float-right" :disabled="isSaveDisabled">
                        <i class="fas fa-save"></i> Guardar
                    </button>

                    <button type="button" class="btn btn-outline-warning float-left" @click="closeModal">
                        Cancelar
                    </button>
                    <br>
                </div>

            </div>

        </form>
    </modal>
</template>

<script>
import request from "@/services/request";
import { mapActions } from "vuex";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import Catalogue from '@/services/catalogue';

export default {
    components: {
        DatePicker
    },

    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            wallet_balance: 0,
            contributionSlots: [],
            form: this.getDefaultForm(),
            contribution_count: 0,
            extra_contribution_count: 0,
        };
    },

    computed: {
        totalPendingAmount() {
            return this.contributionSlots.reduce((sum, slot) => {
                return sum + Number(slot.pending_amount || 0);
            }, 0);
        },
        isAllPendingCovered() {
            return Number(this.totalApplyAmount || 0).toFixed(2) >= Number(this.totalPendingAmount || 0).toFixed(2);
        },
        totalApplyAmount() {
            return this.contributionSlots.reduce((sum, slot) => {
                return sum + Number(slot.apply_amount || 0);
            }, 0);
        },

        isSaveDisabled() {
            const amount = Number(this.form.amount || 0);
            const applied = Number(this.totalApplyAmount || 0);
            const pending = Number(this.totalPendingAmount || 0);

            if (this.form.source_key === 'wallet' && amount > Number(this.wallet_balance)) {
                return true;
            }

            if (applied <= 0) {
                return true;
            }

            if (applied > amount) {
                return true;
            }

            // Mientras aún existan pendientes por cubrir,
            // no se permite sobrante: lo pagado debe ser igual a lo aplicado
            if (applied < pending && amount.toFixed(2) !== applied.toFixed(2)) {
                return true;
            }

            // Si ya cubrió todo lo pendiente, entonces sí puede existir excedente
            if (applied >= pending && amount > applied && !this.form.excess_bank_id) {
                return true;
            }

            return false;
        },

        excessAmount() {
            const amount = Number(this.form.amount || 0);
            const applied = Number(this.totalApplyAmount || 0);
            const totalPending = Number(this.totalPendingAmount || 0);

            // Solo permitir excedente si ya se cubrió todo lo pendiente
            if (applied >= totalPending && amount > applied) {
                return amount - applied;
            }

            return 0;
        },

    },

    methods: {
        getDefaultForm() {
            return {
                program_group_id: "",
                user_id: "",
                company_id: "",
                bank_id: "",
                amount: "",
                source_key: "",
                type_payments_id: null,
                bank_account_company_id: "",
                excess_bank_id: "",
                type_program: 1,
                date: this.formatDate(new Date())
            };
        },

        formatDate(date) {
            return date.toISOString().split('T')[0];
        },

        closeModal() {
            this.errors = {};
            this.wallet_balance = 0;
            this.contributionSlots = [];
            this.form = this.getDefaultForm();
            this.contribution_count = 0;
            this.extra_contribution_count = 0;
            this.$modal.hide("modalProgramGroupContribution");
        },

        normalizeApplyAmount(slot) {
            let value = Number(slot.apply_amount || 0);
            const pending = Number(slot.pending_amount || slot.amount || slot.expected_amount || 0);

            if (value < 0) value = 0;
            if (value > pending) value = pending;

            slot.apply_amount = value;
        },

        buildInstallmentsPayload() {
            return this.contributionSlots
                .filter(slot => Number(slot.apply_amount) > 0)
                .map(slot => ({
                    program_installment_id: slot.id,
                    aportacion_number: slot.number,
                    amount: Number(slot.apply_amount)
                }));
        },

        async saveContribution() {
            const installments = this.buildInstallmentsPayload();

            const payload = {
                program_group_id: this.form.program_group_id,
                user_id: this.form.user_id,
                company_id: this.form.company_id,
                bank_id: this.form.bank_id,
                amount: Number(this.form.amount),
                source_key: this.form.source_key,
                type_payments_id: this.form.type_payments_id,
                bank_account_company_id: this.form.bank_account_company_id,
                excess_amount: Number(this.excessAmount || 0),
                excess_bank_id: this.form.excess_bank_id,
                date: this.form.date,
                type_program: 1,
                installments: installments
            };

            try {
                let { data } = await request.post("/program-group-contributions", payload);
                this.successNotification(data.message);
                this.closeModal();
                Event.$emit("event-reload-program-relations");
            } catch (error) {
                this.errors = await this.errorNotification(error);
            }
        },

        async loadWallet() {
            if (!this.form.user_id || !this.form.bank_id || !this.form.company_id) {
                this.wallet_balance = 0;
                return;
            }

            const user_id = this.form.user_id;
            const company_id = this.form.company_id;
            const bank_id = this.form.bank_id;

            try {
                const { data } = await request.get(`/wallet/${user_id}/${company_id}/${bank_id}`);
                this.wallet_balance = Number(data.balance || 0);
            } catch (error) {
                console.log(error);
                this.wallet_balance = 0;
            }
        },

        async loadContributionSlots(program_id) {
            const url = `/programs/${program_id}/contribution-slots`;
            const { data } = await request.get(url, {
                program_group_id: this.form.program_group_id,
                user_id: this.form.user_id,
                company_id: this.form.company_id
            });


            this.contributionSlots = (data.slots || []).map(slot => ({
                ...slot,
                apply_amount: 0,
                pending_amount: Number(slot.pending_amount || slot.amount || slot.expected_amount || 0)
            }));
        },

        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success",
        })
    },

    created() {
        Event.$on("event-open-program-group-contribution", async (payload) => {
            console.log('-------------');
            console.log(payload);
            this.form.program_group_id = payload.program_group_id;
            this.form.user_id = payload.user_id;
            this.form.company_id = payload.company_id;

            // await this.catalogue.get_bank_accounts_companys(payload.company_id);
            await this.catalogue.get_bank_accounts_groups(payload.program_group_id);
            await this.loadContributionSlots(payload.program_id);
            await this.catalogue.getBankAccountsCompanies(payload.companies_id);

            this.$modal.show("modalProgramGroupContribution");
        });
    }
};
</script>

<style scoped>
.text-danger {
    font-size: 12px;
}

.alert-info {
    background: #041e3f;
}

.table td,
.table th {
    vertical-align: middle;
}
</style>